export default "__VITE_ASSET__Bu6d_Vv8__"